/* IMPORT */
import memo from './memo.js';
import { frozen } from '../objects/callable.js';
import { SYMBOL_OBSERVABLE, SYMBOL_UNTRACKED, SYMBOL_UNTRACKED_UNWRAPPED } from '../symbols.js';
import { isFunction } from '../utils.js';
function resolve(value) {
    if (isFunction(value)) {
        if (SYMBOL_UNTRACKED_UNWRAPPED in value) {
            return resolve(value());
        }
        else if (SYMBOL_UNTRACKED in value) {
            return frozen(resolve(value()));
        }
        else if (SYMBOL_OBSERVABLE in value) {
            return value;
        }
        else {
            return memo(() => resolve(value()));
        }
    }
    if (value instanceof Array) {
        const resolved = new Array(value.length);
        for (let i = 0, l = resolved.length; i < l; i++) {
            resolved[i] = resolve(value[i]);
        }
        return resolved;
    }
    else {
        return value;
    }
}
/* EXPORT */
export default resolve;
